import { useUpdate } from '@lib/systems/update'

class Camera {
  constructor () {
    this.panSpeed = 0.1
    this.position = {
      x: 0,
      y: 0
    }
    this.targetPosition = {
      x: 0,
      y: 0
    }
  }

  translate ({ x, y }) {
    x = Math.round(x)
    y = Math.round(y)
    this.position.x += x
    this.position.y += y
    this.targetPosition.x += x
    this.targetPosition.y += y
  }

  set ({ x, y }) {
    x = Math.round(x)
    y = Math.round(y)
    this.position.x = x
    this.position.y = y
    this.targetPosition.x = x
    this.targetPosition.y = y
  }

  panTo ({ x, y }) {
    x = Math.round(x)
    y = Math.round(y)
    this.targetPosition.x = x
    this.targetPosition.y = y
  }

  update () {
    const dx = (this.targetPosition.x - this.position.x) * this.panSpeed
    const dy = (this.targetPosition.y - this.position.y) * this.panSpeed
    this.position.x += dx
    this.position.y += dy
  }
}

const camera = new Camera()

export function enableCamera () {
  useUpdate(function () {
    camera.update()
  }, {
    updateOrder: -1
  })
}

export function useCamera (x, y) {
  return {
    cameraPosition: camera.position,
    panCameraTo: camera.panTo.bind(camera),
    translateCamera: camera.translate.bind(camera),
    setCamera: camera.set.bind(camera)
  }
}
